<script>
    export let role;    // 'user' or 'ai'
    export let content;
    export let attachments = [];
  </script>
  
  <div class="d-flex {role === 'user' ? 'justify-content-end' : 'justify-content-start'} mb-2">
    {#if role === 'ai'}
      <div class="me-2 d-flex align-items-end">
        <i class="bi-robot text-secondary" style="font-size: 1.5rem;"></i>
      </div>
    {/if}
  
    <div
      class="message-bubble shadow-sm 
             {role === 'user' ? 'bg-dark text-white' : 'bg-white text-dark border border-dark'}"
    >
      {@html content.replace(/\n/g, '<br>')}
      <!-- Show attached files -->
      {#if attachments?.length > 0}
          <div class="file-attachments p-3 bg-light text-dark">
              <strong>📂 Attachments:</strong>
              <ul>
                  {#each attachments as file}
                      <li>{file.name}</li>
                  {/each}
              </ul>
          </div>
      {/if}
    </div>
  
    {#if role === 'user'}
      <div class="ms-2 d-flex align-items-end">
        <i class="bi-person-fill text-primary" style="font-size: 1.5rem;"></i>
      </div>
    {/if}
  </div>
  
  <style>
    .message-bubble {
      padding: 0.75rem 1rem;
      border-radius: 12px;
      white-space: pre-wrap;
      word-wrap: break-word;
      max-width: 70%;
    }
    .bubble-user {
      background-color: #cbe4f9; /* Slightly lighter blue */
    }
    .bubble-ai {
      background-color: #fff;
      border: 1px solid #ddd;
    }
    .file-attachments {
        font-size: 0.9rem;
        color: #555;
        background: #f8f9fa;
        padding: 5px;
        border-radius: 5px;
        margin-top: 5px;
    }

    .file-attachments ul {
        padding-left: 15px;
    }

  </style>
  